// src/hooks/useDashboardAnalytics.js
import { useState, useEffect } from "react";
import { dashboardService } from "../services/dashboardService";

export const useDashboardAnalytics = () => {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await dashboardService.getAnalytics();
        setAnalyticsData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { analyticsData, loading, error };
};